import { defineStore as define_store } from 'pinia'
import { ref } from 'vue'
import { callable } from '@/utils/serverless'

export const use_notify = define_store('notifier', () => {
  const content = ref('')
  const snackbar_color = ref('primary')

  const log = (...args) => {
    console.info(...args)
    const safe_args = args.map(arg => {
      try {
        JSON.parse(JSON.stringify(arg))
        return arg
      } catch {
        return String(arg)
      }
    })
    callable('log')(safe_args)
  }

  const track_error = (error: Error | string, context = {}) => {
    const error_data = {
      message: error instanceof Error ? error.message : error,
      stack: error instanceof Error ? error.stack : undefined,
      context,
      timestamp: new Date().toISOString()
    }
    console.log('track error')
    console.error(error_data)
    callable('log')(error_data)
  }

  const notify = (message = '', color = 'primary') => {
    content.value = message
    snackbar_color.value = color
  }

  // Global error handlers
  const setup_error_handlers = () => {
    window.onerror = (message, source, lineno, colno, error) => {
      track_error(error || message, { source, lineno, colno })
      return false // Let error propagate to console
    }

    window.onunhandledrejection = event => {
      track_error(event.reason, { type: 'unhandledRejection' })
    }
  }

  return {
    content,
    snackbar_color,
    notify,
    log,
    track_error,
    setup_error_handlers
  }
})
